import BaseCommand from "@/models/api/commands/BaseCommand";
import { TRADE_TERM_APPLY_TO } from "@/static/tradeTermApplyToTypes";

export class AddBookingItemTradeTermCommand extends BaseCommand {
  CommandName = "AddBookingItemTradeTerm";
  Command: {
    BookingItemTmpId: string;
    Amount: number;
    IsHidden: boolean;
    SeparateItem: boolean;
    ServiceTypeCode: string | null;
    AppliesTo: TRADE_TERM_APPLY_TO | null;
  };
  constructor(
    sessionId: string,
    operationId: string,
    bookingItemTmpId: string,
    amount: number,
    isHidden: boolean,
    separateItem: boolean,
    serviceTypeCode: string | null,
    appliesTo: TRADE_TERM_APPLY_TO | null
  ) {
    super(sessionId, operationId);
    this.Command = {
      BookingItemTmpId: bookingItemTmpId,
      Amount: amount,
      IsHidden: isHidden,
      SeparateItem: separateItem,
      ServiceTypeCode: serviceTypeCode,
      AppliesTo: appliesTo,
    };
  }
}
